
export default {
  props: {
    price: { type: [Number, String], required: true },
    locale: { type: String, default: 'en-AU' },
    currency: { type: String, default: 'AUD' },
  },
};
